<div fxLayout="row" fxLayoutAlign="center" class="keyboard-container">
  <div
  fxFlex
    #keyboard
    class="simple-keyboard"
    (clickOutside)="closeKeyboard()"
    [ngClass]="keyboardService.keyboardIsActive() ? '' : 'hide-keyboard'"
  >
    <!-- <h4>{{ inputName }} : {{ this.keyboardService.keyboardValue }}</h4> -->
  </div>
</div>
